import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useRef, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import RichTextEditor from '../../../../components/Form/RichTextEditor';
import LanguageManagerGuard from '../../../../components/Language/LanguageManagerGuard';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useToastContext } from '../../../../contexts/ToastContext';
import ImageForm from '../../common/image/ImageForm';

function NewsManager({ isOpen, onClose, news, loading, onUpdate, onCreate }) {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(undefined);
  const { showToast } = useToastContext();
  const fileUploadRef = useRef(null);

  const { accountContext } = useAccountContext();

  useEffect(() => {
    if (news) {
      setTitle(news.title);

      setImage(news.image);
      setContent(news.content);
    } else {
      setTitle('');
      setImage(undefined);
      setContent('');
    }
  }, [news, isOpen]);

  const handleValidate = () => {
    const newsPayload = {
      title,
      image: image?.id,
      content
    };
    news ? onUpdate(newsPayload) : onCreate(newsPayload);
  };

  const formIsValid = () => {
    return title && image && content;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${news ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${news ? 'Modifier' : 'Ajouter'} un article`}</h3>
      }>
      <LanguageManagerGuard isCreation={!news}>
        <div className="sidebar-content-container">
          <div className="form-wrapper !pb-60">
            <FormInput label={`Titre de l'article`} required isValid={title.length} translatable>
              <InputText
                id="title"
                value={title}
                maxLength={300}
                placeholder="Veuillez saisir le titre de l'article"
                onChange={(e) => setTitle(e.target.value)}
              />
            </FormInput>
            <FormInput label={'Contenu'} required isValid={content} translatable>
              <RichTextEditor
                value={content}
                onChange={(value) => {
                  setContent(value);
                }}
                acceptHeaders
                headerList={[3, 4, false]}
              />
            </FormInput>
            <ImageForm image={image} setImage={setImage} deleteImage={() => setImage(undefined)} />
          </div>
          {footerButtons}
        </div>
      </LanguageManagerGuard>
    </Sidebar>
  );
}

export default NewsManager;
